import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ROUTE_TITLES: Record<string, string> = {
  '/branches': 'browser.tab.title.enquiry.editor',
  '/history': 'browser.tab.title.enquiry.history',
  '/shell': 'browser.tab.title.enquiry.shell',
  '/user-management': 'browser.tab.title.user.management',
  '/editor': 'browser.tab.title.enquiry.editor',
  '/consent-management': 'browser.tab.title.consent.management',
};

const BrowserTabTitleManager = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Match the start of the path to handle dynamic segments like /branches/:branchName
    const matchedKey = Object.keys(ROUTE_TITLES).find((key) => location.pathname.startsWith(key));
    document.title = matchedKey ? t(ROUTE_TITLES[matchedKey]) : t('browser.tab.title.rules.editor');
  }, [location.pathname]);

  return null; // renders nothing
};

export default BrowserTabTitleManager;
